import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdIntegrationStatus } from './types';
import { invalidateRegEdIntegration, setRegEdIntegration } from './useRegEdIntegrationQuery';

/** Body is only `brokerDealerId` — credentials are provisioned globally per broker-dealer, never per account. */
export const useRegEdIntegrationUpsertMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IRegEdIntegrationStatus) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			brokerDealerId,
			impersonationContext,
		}: {
			brokerDealerId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IRegEdIntegrationStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'compliance/regEd/integration',
				}),
				'POST',
				{ brokerDealerId }
			),
		onError,
		onSuccess: (result, { impersonationContext }) => {
			setRegEdIntegration(impersonationContext?.account?.id, result);
			invalidateRegEdIntegration();
			onSuccess?.(result);
		},
	});
};
